<template>
    <RentalMessage :rental="message.rental" :date="message.created_at">
        <div class="flex items-center">
            <img src="@/assets/img/icon_decline.svg"/>
            <h6 class="ml2">Cancelled</h6>
        </div>
    </RentalMessage>
</template>

<script>
import RentalMessage from '@/components/inbox/messagesCard/shared/RentalMessage.vue';

export default {
    components: {
        RentalMessage
    },
    props: {
        message: {
            type: Object
        }
    }
};
</script>
